import { render, staticRenderFns } from "./LeadFormButton.vue?vue&type=template&id=d4080cfc&"
import script from "./LeadFormButton.vue?vue&type=script&lang=ts&"
export * from "./LeadFormButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports